import { useEffect, useRef } from 'react';
import store from '../store';
import { updateStatusMessageConversationInAttendance } from '../store/action/conversation-in-attendance-action';

const SSE_BASE_URL =
  'https://testesqa.g4flex.com.br:9090/flex-chat-integration/api/messages/status';

/**
 * Hook que gerencia a conexão SSE com o servidor.
 * Reconecta automaticamente via EventSource nativo do browser.
 */
export function useServerSentEvents(handlers) {
  const handlersRef = useRef({
    ...handlers,
    eventStatusMessage: async (payload) => {
      await store.dispatch(
        updateStatusMessageConversationInAttendance(payload.message)
      );
      if (handlers && handlers.eventStatusMessage) {
        handlers.eventStatusMessage(payload);
      }
    }
  });

  useEffect(() => {
    handlersRef.current = {
      ...handlers,
      eventStatusMessage: async (payload) => {
        await store.dispatch(
          updateStatusMessageConversationInAttendance(payload.message)
        );
        if (handlers && handlers.eventStatusMessage) {
          handlers.eventStatusMessage(payload);
        }
      }
    };
  }, [handlers]);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      console.warn('[SSE] Token não encontrado, não conectando.');
      return;
    }

    const url = `${SSE_BASE_URL}?jwt=${encodeURIComponent(token)}`;
    const es = new EventSource(url);

    es.addEventListener('connected', (e) => {
      console.info('[SSE] Conectado:', JSON.parse(e.data));
    });

    // Registra dinamicamente um listener para cada evento do mapa de handlers
    const registeredEvents = Object.keys(handlersRef.current);

    registeredEvents.forEach((event) => {
      es.addEventListener(event, (e) => {
        try {
          const payload = JSON.parse(e.data);
          console.log(payload);
          const handler = handlersRef.current[event];
          if (handler) handler(payload);
        } catch (err) {
          console.error(`[SSE] Erro ao parsear evento "${event}"`, err);
        }
      });
    });

    es.onerror = () => {
      console.warn(
        '[SSE] Erro na conexão. Browser tentará reconectar automaticamente.'
      );
    };

    return () => {
      es.close();
      console.info('[SSE] Conexão encerrada.');
    };
  }, []);
  return null;
}
